import request from '@/utils/request'
let baseURL = '/pay-api';


// 余额支付、获取签名
export function getPaySignInfo(data) {
  return request({
    url: '/pay/v1/public/getPaySignInfo',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
amount (string): 支付金额 ,
orderNo (string): 订单号 ,
orderType (integer): 订单类型，0：直播点卡，1：商城购物 ,
payPassword (string, optional): 交易密码 ,
payType (string): 付款方式(aliPay:支付宝, wxPay:微信, wxH5Pay:微信H5, JSAPI:微信JS支付 blcPay:现金余额，antPay:金币余额) ,
userOpenid (string): 付款者openid，与用户表openid关联 ,
walletType (integer, optional): 钱包类型，0：个人钱包，1：店铺钱包 ,

wapName (string, optional): WAP 网站名 ,-----支付方式为 wxH5Pay 时，需传该字段
wapType (string, optional): 微信H5场景类型 ,-----支付方式为 wxH5Pay 时，需传该字段
wapUrl (string, optional): WAP网站URL地址-----支付方式为 wxH5Pay 时，需传该字段
wxCase (integer, optional): 1原公众号，2：第二套
}
* */


//统计用户全部提现总额
export function totalWithdrawal(data) {
  return request({
    url: '/withdrawal/v1/totalWithdrawal',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
walletAccount (string): 钱包帐号
}
* */



// 现金钱包余额转帐(通用接口)
export function currencyCashTransfer(data) {
  return request({
    url: '/cash/v1/currencyCashTransfer',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
fromUserOpenId (string): 转出用户openId，平台的ID为0000000 ,
fromWalletType (integer): 转出钱包类型，0：个人钱包，1：店铺钱包 ,
isFrozen (boolean): 转入方是否要冻结，true：是 false：否 ,
money (string): 转帐金额 ,
orderNo (string, optional): 订单号，非必填，只有充值的才有订单号 ,
payType (string, optional): 支付类型，aliPay：支付宝，wxPay：微信，blcPay：余额 ,
remarks (string, optional): 备注信息 ,
toUserOpenId (string): 转入用户openId ,
toWalletType (integer): 转入钱包类型，0：个人钱包，1：店铺钱包 ,
type (integer): 交易类型，1-现金充值；2-结算；3-退款；4-红包；5-邀请会员奖励；6-购买金币；7-提现；8-购买商品；9-分润
}
* */


// 提现手续费
export function cashRule(data) {
  return request({
    url: '/withdrawal/v1/rule',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
walletAccount (string): 钱包帐号
}
* */